module.exports = __webpack_public_path__ + "img/shadow-pro-landscape-soft.b7f3645.png";